(() => {
  if (customElements.get('author-related-articles')) return;

  const normalizeUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.pathname;
    } catch (error) {
      return value;
    }
  };

  class AuthorRelatedArticles extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-ref="list"]');
      this.viewAll = this.querySelector('[data-ref="view-all"]');
      this.load();
    }

    get limit() {
      return Number.parseInt(this.dataset.limit, 10) || 3;
    }

    get tagUrl() {
      if (!this.dataset.blogUrl || !this.dataset.authorHandle) return '';
      return `${this.dataset.blogUrl}/tagged/author-${this.dataset.authorHandle}`;
    }

    get searchUrl() {
      if (!this.dataset.searchUrl || !this.dataset.authorName) return '';
      const query = `"${this.dataset.authorName}"`;
      return `${this.dataset.searchUrl}?type=article&options%5Bprefix%5D=last&q=${encodeURIComponent(query)}`;
    }

    async fetchDocument(url) {
      if (!url) return null;
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) return null;
      const markup = await response.text();
      return new DOMParser().parseFromString(markup, 'text/html');
    }

    tagCards(documentNode) {
      if (!documentNode) return [];
      return Array.from(documentNode.querySelectorAll("ul[data-ref='article-grid'] > li"))
        .map((item) => ({
          url: normalizeUrl(item.querySelector('a[href]')?.href || ''),
          node: item.cloneNode(true),
        }))
        .filter((item) => item.url.includes('/blogs/news/'));
    }

    searchCards(documentNode) {
      if (!documentNode) return [];
      const results = Array.from(documentNode.querySelectorAll('ul.c-search__result-grid > li'));

      return results.flatMap((result) => {
        const sourceLink = result.querySelector(':scope > a.c-search__result-link[href*="/blogs/news/"]');
        const sourceArticle = sourceLink?.querySelector('article');
        const sourceTitle = sourceArticle?.querySelector('h2, h3');
        if (!sourceLink || !sourceArticle || !sourceTitle) return [];

        const item = document.createElement('li');
        const card = document.createElement('article');
        const link = document.createElement('a');
        const title = document.createElement('h3');
        const readMore = document.createElement('a');
        const sourceImage = sourceArticle.querySelector('img');
        const path = normalizeUrl(sourceLink.href);

        card.className = 'c-article-card vl-blog-article-card vl-author-related-card';
        link.className = 'c-article-card__link';
        link.href = path;

        if (sourceImage) {
          const image = sourceImage.cloneNode(true);
          image.className = 'c-article-card__image a-image-background';
          link.appendChild(image);
        }

        title.className = 'c-article-card__title';
        title.textContent = sourceTitle.textContent.trim();
        link.appendChild(title);

        readMore.className = 'vl-article-card__read-more';
        readMore.href = path;
        readMore.textContent = this.dataset.readMore || 'Leer más';
        readMore.setAttribute('aria-label', `${readMore.textContent}: ${title.textContent}`);

        card.append(link, readMore);
        item.appendChild(card);
        return [{ url: path, node: item }];
      });
    }

    async load() {
      if (!this.list) return;

      try {
        const [tagDocument, searchDocument] = await Promise.all([
          this.fetchDocument(this.tagUrl),
          this.fetchDocument(this.searchUrl),
        ]);
        const merged = [...this.tagCards(tagDocument), ...this.searchCards(searchDocument)];
        const unique = [];
        const seen = new Set();

        for (const card of merged) {
          if (!card.url || seen.has(card.url)) continue;
          seen.add(card.url);
          unique.push(card);
        }

        if (!unique.length) return;

        for (const card of unique.slice(0, this.limit)) {
          this.list.appendChild(card.node);
        }

        if (unique.length > this.limit && this.viewAll) {
          const link = this.viewAll.querySelector('a');
          if (link) link.href = this.tagCards(tagDocument).length > this.limit ? this.tagUrl : this.searchUrl;
          this.viewAll.hidden = false;
        }

        this.hidden = false;
      } catch (error) {
        console.warn('No se pudieron cargar los artículos relacionados.', error);
      }
    }
  }

  customElements.define('author-related-articles', AuthorRelatedArticles);
})();
